export const formatIndianMoney = (amount) => {
  if (isNaN(amount)) return "0";

  return new Intl.NumberFormat("en-IN", {
    maximumFractionDigits: 2
  }).format(amount);
}